import { SystemEvent } from '@mbrtargeting/metatag-shared-types/metatag-core';
import { triggerEvent } from '../loader/essentials/events.js';
import { MetaTag } from '../loader/essentials/init-metatag.js';
import { log } from '../loader/essentials/logger.js';
import { patchLegacyStuffToSDG } from './legacy.js';
import { MetaTagAdhesionUnitWatcher } from './modules/adhesion-unit-watcher/adhesion-unit-watcher.js';
import { AdslotController } from './modules/adslot-controller/adslot-controller.js';
import { PublicAdvertisingApi } from './modules/apis/public-advertising-api.js';
import { PublicInfotoolAPI } from './modules/apis/public-infotool-api.js';
import { AudienceProject } from './modules/audienceproject/audienceproject.js';
import { MetaTagContentObjectWatcher } from './modules/content-object-watcher/content-object-watcher.js';
import { CssInjector } from './modules/css-injector/css-injector.js';
import { FormatController } from './modules/format-controller/format-controller.js';
import { FullPublisherAPI } from './modules/full-publisher-api/full-publisher-api.js';
import { RingierGamAdserver, StroeerGamAdserver } from './modules/gam-adserver/gam-adserver.js';
import { CountryCodeTargeting } from './modules/generic-targeting/country-code-targeting.js';
import { GenericTargeting } from './modules/generic-targeting/generic-targeting.js';
import { MetaKeywordsCollector } from './modules/generic-targeting/meta-keyswords.js';
import { GlobalSettings } from './modules/global-settings/global-settings.js';
import { GlobalTargeting } from './modules/global-targeting/global-targeting.js';
import { IdStore } from './modules/idstore/idstore.js';
import { RecoverPrebidIds } from './modules/idstore/recover-prebid-ids.js';
import { LoadAdLibrary } from './modules/load-ad-library/load-ad-library.js';
import { MbrId } from './modules/mbrid/mbrid.js';
import { NativeBackfill } from './modules/native-backfill-demand-source/native-backfill.js';
import { NetIdTracking } from './modules/netid/netid-tracking.js';
import { NetId } from './modules/netid/netid.js';
import { PhaseController } from './modules/phase-controller/phase-controller.js';
import { SamTargeting } from './modules/sam/sam.js';
import { SpeedCurve } from './modules/speedcurve/speedcurve.js';
import { StorageHelper } from './modules/storage/storage-helper.js';
import { StroeerSsp } from './modules/stroeerssp/stroeerssp.js';
import { UtiqTracking } from './modules/utiq/utiq-tracking.js';
import { Utiq } from './modules/utiq/utiq.js';
import { VastTagGenerator } from './modules/video/vast-tag-generator.js';
import { DoubleverifyTrackingAdSlotAddon } from './modules/viewability/doubleverify-tracking.js';
import { Yieldlove } from './modules/yieldlove/yieldlove.js';

declare const SDG: MetaTag;

SDG.registerModule('GlobalSettings', GlobalSettings);
SDG.registerModule('ContentObjectWatcher', MetaTagContentObjectWatcher);
SDG.registerModule('FormatController', FormatController);
SDG.registerModule('AdhesionUnitWatcher', MetaTagAdhesionUnitWatcher);
SDG.registerModule('StorageHelper', StorageHelper);
SDG.registerModule('GlobalTargeting', GlobalTargeting);
SDG.registerModule('IdStore', IdStore);
SDG.registerModule('RecoverPreBidIds', RecoverPrebidIds);
SDG.registerModule('NetIdTracking', NetIdTracking);
SDG.registerModule('NetId', NetId);
SDG.registerModule('MbrId', MbrId);
SDG.registerModule('UtiqTracking', UtiqTracking);
SDG.registerModule('Utiq', Utiq);
SDG.registerModule('GenericTargeting', GenericTargeting);
SDG.registerModule('MetaKeywordsCollector', MetaKeywordsCollector);
SDG.registerModule('StroeerGamAdserver', StroeerGamAdserver);
SDG.registerModule('RingierGamAdserver', RingierGamAdserver);
SDG.registerModule('StroeerSsp', StroeerSsp);
SDG.registerModule('Yieldlove', Yieldlove);
SDG.registerModule('NativeBackfill', NativeBackfill);
SDG.registerModule('CssInjector', CssInjector);
SDG.registerModule('AdslotController', AdslotController);
SDG.registerModule('PhaseController', PhaseController);
SDG.registerModule('VastTagGenerator', VastTagGenerator);
SDG.registerModule('PublicInfotoolAPI', PublicInfotoolAPI);
SDG.registerModule('FullPublisherAPI', FullPublisherAPI);
SDG.registerModule('DoubleVerifyTrackingAdSlotAddon', DoubleverifyTrackingAdSlotAddon);
SDG.registerModule('AdLibrary', LoadAdLibrary);
SDG.registerModule('AdvertisingApi', PublicAdvertisingApi);
SDG.registerModule('SamTargeting', SamTargeting);
SDG.registerModule('SpeedCurve', SpeedCurve);
SDG.registerModule('CountryCodeTargeting', CountryCodeTargeting);
SDG.registerModule('AudienceProject', AudienceProject);

patchLegacyStuffToSDG();

triggerEvent(SystemEvent.SDG_CORE_FILE_LOADED, {});

//legacy for some publisher, namely SMB and OMS. See shared-types documentation for these events.
triggerEvent(SystemEvent.SDG_AD_SERVER_MODULE_LOADED, {});
triggerEvent(SystemEvent.SDG_CRITICAL_MODULES_LOADED, {});
triggerEvent(SystemEvent.SDG_WINDOW_LOAD_COMPLETE, {});

log.info('MetaTag2 Core - Version %s', [__METATAG_VERSION__]);
